import { smooth, TAU } from "../orbit";
import { BREAK, CLIMAX, FINAL_BEAT, PARTS, RETURN, timeBeat, type InstrumentId, type Note } from "./score";

export const ORBITS: readonly {id: InstrumentId; radius: number; color: string; release: number}[] = [
  {id:"brass",radius:385,color:"#FFB35C",release:.48},
  {id:"strings",radius:295,color:"#74EEFF",release:.32},
  {id:"bass",radius:205,color:"#B29AFF",release:.56},
  {id:"percussion",radius:115,color:"#FF7398",release:.18},
];
export const entryWeight = (id: InstrumentId, time: number) =>
  id === "brass" ? 1 : smooth((time - (PARTS[id][0].time-.24))/.24);
export const markerAngle = (e: Note, time: number) =>
  -Math.PI/2 + TAU*(timeBeat(e.finale ? Math.min(time,CLIMAX) : time)-e.startBeat)/2;
export const markerVisible = (e: Note, time: number) => {
  const d=timeBeat(time)-e.startBeat;
  return d > -1.9 && (d < .15 || (e.finale && time < 18));
};
export const position = (e: Note,time: number,radius: number) => ({
  x:Math.cos(markerAngle(e,time))*radius,
  y:Math.sin(markerAngle(e,time))*radius,
});
export const hit = (e: Note,time: number,decay: number) =>
  time<e.time ? 0 : e.velocity*Math.exp(-(time-e.time)/decay);
export const latest = (id: InstrumentId,time: number) =>
  [...PARTS[id]].reverse().find(e=>e.time<=time);
export const finalePulse = (time: number) =>
  time<CLIMAX ? 0 : Math.exp(-(time-CLIMAX)/.65);
export const returnPulse = (time: number) =>
  time<RETURN ? 0 : Math.exp(-(time-RETURN)/.34);
export const breakWeight = (time: number) => {
  if(time<BREAK || time>=RETURN) return 1;
  return .28 + .24*smooth((time-(RETURN-.20))/.20);
};
export const anticipation = (time: number) =>
  time<BREAK || time>=RETURN ? 0 : smooth((time-(RETURN-.24))/.24);
export const rotation = (time: number) =>
  (time<=CLIMAX ? timeBeat(time) : FINAL_BEAT) * 180;
export const iconPose = (id: InstrumentId,time: number) => {
  const e=latest(id,time);
  if(!e) return {jump:0,scale:1,rotate:0,glow:0,age:10,velocity:0};
  const age=time-e.time, v=e.velocity;
  const life=e.finale ? .66 : e.returnHit ? .54 :
    {brass:.26,strings:.19,bass:.4,percussion:.18}[id];
  const u=Math.min(1,age/life);
  const bump=u>=1 ? 0 : Math.sin(Math.PI*u)**1.2;
  return {
    jump:bump*v*(e.finale ? 52 : e.returnHit ? 45 :
      {brass:35,strings:25,bass:42,percussion:29}[id]),
    scale:1+bump*v*(e.finale ? .31 : e.returnHit ? .27 : .2),
    rotate:(id==="percussion" ? 16 : id==="brass" ? -7 : 5)*v*
      Math.sin(u*Math.PI*2)*Math.exp(-2*u),
    glow:hit(e,time,e.finale ? .45 : .18), age, velocity:v,
  };
};
